import { PaymentImputation } from "../../models/Entities/CashFlow/Payment/PaymentImputation";
import { ErrorType } from "../../models/HttpError";

export interface CashFlowPaymentImputationsState {
    // loading imputations
    isLoadingImputations: boolean;
    successLoadingImputations: boolean | undefined;
    failOnLoadingImputations: boolean;

    // rollback
    isRollingBack: boolean;
    successRollingBack: boolean | undefined;
    failOnRollingBack: boolean;

    // create
    isCreatingImputation: boolean;
    successCreatingImputation: boolean | undefined;
    failOnCreatingImputation: boolean;

    // current payment id context
    currentPaymentId: number | undefined;

    // imputations list
    imputations: PaymentImputation[];

    error: ErrorType | undefined;
}

export const PaymentImputationsUnloadState: CashFlowPaymentImputationsState = {
    isLoadingImputations: false,
    successLoadingImputations: undefined,
    failOnLoadingImputations: false,

    isRollingBack: false,
    successRollingBack: undefined,
    failOnRollingBack: false,

    isCreatingImputation: false,
    successCreatingImputation: undefined,
    failOnCreatingImputation: false,

    currentPaymentId: undefined,
    imputations: [],

    error: undefined
};
